import { useMutation } from '@tanstack/react-query';
import { manifestarNfseApi } from '../api/ManifestarNfseApi';
import type { ManifestarNfsePayload, ManifestarNfseResultado } from '../types';

export function useManifestarNfse() {
  return useMutation<ManifestarNfseResultado | null, Error, ManifestarNfsePayload>({
    mutationFn: manifestarNfseApi,
  });
}
